import { graphql } from "@opensea/graphql"
import { ItemMediaFragment } from "../../ItemMedia/ItemMedia.fragment"

export const ItemCardMediaFragment = graphql(
  `
    fragment ItemCardMedia on Item {
      id
      tokenId
      ...ItemMedia
    }
  `,
  [ItemMediaFragment],
)
